export default __webpack_public_path__ + "static/media/Document2.a7fa97cd.jpg";